import React, { useState, useEffect } from 'react'
import { BsCheck, BsFilter } from 'react-icons/bs';
import Select from "react-select";
import { sweetalert } from '../../App'
import { AnimalSampleFilter, SampleFilter } from '../../types/Sample'
import { getBoolOptionsWithNullString, getFacilityLabel, getLabel, getNameFromID, getNullOptions, getUnwrappedSelect, parseDate, prepareMultiSelect } from '../../util/FormatUtil'
import moment from 'moment';
import PhoneInput from "react-phone-number-input";
import CustomInput from '../form/CustomInput';
import CustomSelect from '../form/CustomSelect';
import CustomDate from '../form/CustomDate';
import CustomPhone from '../form/CustomPhone';
import { customStyles } from '../../util/FormatUtil';
import { keyframes } from 'styled-components';

//get filtered object to return

const AnimalSampleFilterTabs = (props, ref) => {

    const [filterObj, setFilterObj] = useState<AnimalSampleFilter>({
        AnimalType: null,
        PodID: null,
        FacilityID: null,
        FacilityGroup: null,
        SubmitterFirstName: "",
        SubmitterLastName: "",
        SubmitterEmail: "",
        SubmitterPhone: "",
        NullSubmitterPhone: null,
        Status: [{label: "Processing", value: 1}],
        LinkedApptsID: "",
        ReqNum: "",
        BatchNum: "",
        SpecimenID: "",
        InternalSpecimenID: "",
        BinID: "",
        Lot: "",
        BeginCreatedDate: null,
        EndCreatedDate: null,
        NullCreatedDate: null,
        BeginCollectionDate: null,
        EndCollectionDate: null,
        NullCollectionDate: null,
        BeginReceivedDate: null,
        EndReceivedDate: null,
        NullReceivedDate: null,
        BeginResultDate: null,
        EndResultDate: null,
        NullResultDate: null,
        BeginResultsApprovedDate: null,
        EndResultsApprovedDate: null,
        NullResultsApprovedDate: null,
        BeginResultsAccessedDate: null,
        EndResultsAccessedDate: null,
        NullResultsAccessedDate: null,
        BeginReportedDate: null,
        EndReportedDate: null,
        NullReportedDate: null,
        ResultIDs: "",
        SpecimenSourceID: "",
        TestIDs: "",
        // ProviderFirstName: "",
        // ProviderLastName: "",
        ServiceID: null,
        BeginTestOrderedDate: null,
        EndTestOrderedDate: null,
        NullTestOrderedDate: null,
        SubmittingProvider: ""
    })
    const [isApptFilterActive, setIsApptFilterActive] = useState(false)
    const [isSampleFilterActive, setIsSampleFilterActive] = useState(false)
    const [isFacilityFilterActive, setIsFacilityFilterActive] = useState(false)
    const [isSubmitterFilterActive, setIsSubmitterFilterActive] = useState(false)
    const [isApptTabActive, setIsApptTabActive] = useState(true)
    const [isSampleTabActive, setIsSampleTabActive] = useState(false)
    const [isFacilityTabActive, setIsFacilityTabActive] = useState(false)
    const [isSubmitterTabActive, setIsSubmitterTabActive] = useState(false)


    const getFilterObj = () => {
        return {
            AnimalType: filterObj.AnimalType ? prepareMultiSelect(filterObj.AnimalType) : null,
            PodID: filterObj.PodID ? getUnwrappedSelect(filterObj.PodID) : null,
            Facilities: filterObj.FacilityID ? prepareMultiSelect(filterObj.FacilityID) : null,
            FacilityGroup: filterObj.FacilityGroup ? prepareMultiSelect(filterObj.FacilityGroup) : null,
            SubmitterFirstName: filterObj.SubmitterFirstName ? filterObj.SubmitterFirstName : null,
            SubmitterLastName: filterObj.SubmitterLastName ? filterObj.SubmitterLastName : null,
            SubmitterEmail: filterObj.SubmitterEmail ? filterObj.SubmitterEmail : null,
            SubmitterPhone: filterObj.SubmitterPhone ? filterObj.SubmitterPhone : null,
            NullSubmitterPhone: filterObj.NullSubmitterPhone ? filterObj.NullSubmitterPhone : null,
            Status: filterObj.Status ? prepareMultiSelect(filterObj.Status) : null,
            LinkedApptsID: filterObj.LinkedApptsID ? filterObj.LinkedApptsID : null,
            ReqNum: filterObj.ReqNum ? filterObj.ReqNum : null,
            BatchNum: filterObj.BatchNum ? prepareMultiSelect(filterObj.BatchNum) : null,
            SpecimenID: filterObj.SpecimenID ? filterObj.SpecimenID : null,
            InternalSpecimenID: filterObj.InternalSpecimenID ? filterObj.InternalSpecimenID : null,
            BinID: filterObj.BinID ? prepareMultiSelect(filterObj.BinID) : null,
            Lot: filterObj.Lot ? filterObj.Lot : null,
            BeginCreatedDate: filterObj.NullCreatedDate ? null : filterObj.BeginCreatedDate ? filterObj.BeginCreatedDate : null,
            EndCreatedDate: filterObj.NullCreatedDate ? null : filterObj.EndCreatedDate ? filterObj.EndCreatedDate : null,
            NullCreatedDate: filterObj.NullCreatedDate ? filterObj.NullCreatedDate : null,
            BeginCollectionDate: filterObj.NullCollectionDate ? null : filterObj.BeginCollectionDate ? filterObj.BeginCollectionDate : null,
            EndCollectionDate: filterObj.NullCollectionDate ? null : filterObj.EndCollectionDate ? filterObj.EndCollectionDate : null,
            NullCollectionDate: filterObj.NullCollectionDate ? filterObj.NullCollectionDate : null,
            BeginReceivedDate: filterObj.NullReceivedDate ? null : filterObj.BeginReceivedDate ? filterObj.BeginReceivedDate : null,
            EndReceivedDate: filterObj.NullReceivedDate ? null : filterObj.EndReceivedDate ? filterObj.EndReceivedDate : null,
            NullReceivedDate: filterObj.NullReceivedDate ? filterObj.NullReceivedDate : null,
            BeginResultDate: filterObj.NullResultDate ? null : filterObj.BeginResultDate ? filterObj.BeginResultDate : null,
            EndResultDate: filterObj.NullResultDate ? null : filterObj.EndResultDate ? filterObj.EndResultDate : null,
            NullResultDate: filterObj.NullResultDate ? filterObj.NullResultDate : null,
            BeginResultsApprovedDate: filterObj.NullResultsApprovedDate ? null : filterObj.BeginResultsApprovedDate ? filterObj.BeginResultsApprovedDate : null,
            EndResultsApprovedDate: filterObj.NullResultsApprovedDate ? null : filterObj.EndResultsApprovedDate ? filterObj.EndResultsApprovedDate : null,
            NullResultsApprovedDate: filterObj.NullResultsApprovedDate ? filterObj.NullResultsApprovedDate : null,
            BeginResultsAccessedDate: filterObj.NullResultsAccessedDate ? null : filterObj.BeginResultsAccessedDate ? filterObj.BeginResultsAccessedDate : null,
            EndResultsAccessedDate: filterObj.NullResultsAccessedDate ? null : filterObj.EndResultsAccessedDate ? filterObj.EndResultsAccessedDate : null,
            NullResultsAccessedDate: filterObj.NullResultsAccessedDate ? filterObj.NullResultsAccessedDate : null,
            BeginReportedDate: filterObj.NullReportedDate ? null : filterObj.BeginReportedDate ? filterObj.BeginReportedDate : null,
            EndReportedDate: filterObj.NullReportedDate ? null : filterObj.EndReportedDate ? filterObj.EndReportedDate : null,
            NullReportedDate: filterObj.NullReportedDate ? filterObj.NullReportedDate : null,
            ResultIDs: filterObj.ResultIDs ? prepareMultiSelect(filterObj.ResultIDs) : null,
            SpecimenSourceID: filterObj.SpecimenSourceID ? prepareMultiSelect(filterObj.SpecimenSourceID) : null,
            TestIDs: filterObj.TestIDs ? prepareMultiSelect(filterObj.TestIDs) : null,
            ServiceID: filterObj.ServiceID ? prepareMultiSelect(filterObj.ServiceID) : null,
            //passing empty array if greater than 1 because if both 1 and null are selected then that is all the records.  same for ApptCanceled
            // ProviderFirstName: filterObj.ProviderFirstName ? filterObj.ProviderFirstName : null,
            // ProviderLastName: filterObj.ProviderLastName ? filterObj.ProviderLastName : null,
            BeginTestOrderedDate: filterObj.NullTestOrderedDate ? null : filterObj.BeginTestOrderedDate ? filterObj.BeginTestOrderedDate : null,
            EndTestOrderedDate: filterObj.NullTestOrderedDate ? null : filterObj.EndTestOrderedDate ? filterObj.EndTestOrderedDate : null,
            NullTestOrderedDate: filterObj.NullTestOrderedDate ? filterObj.NullTestOrderedDate : null,
            SubmittingProvider: filterObj.SubmittingProvider ? filterObj.SubmittingProvider : null 
        };
    }

    const dateCheck = (beginDateState, endDateState, beginLabel, endLabel, label) => {
        let valid = true
        if ((beginDateState && !endDateState) || (!beginDateState && endDateState)) {
            sweetalert.fire({
                icon: "error",
                title: "",
                text: `Please enter a valid ${beginLabel} Date and an ${endLabel} Date`,
            });
            valid = false;
        }

        if (beginDateState > endDateState) {
            sweetalert.fire({
                icon: "error",
                title: "",
                text: `${beginLabel} Date cannot be after ${endLabel} Date`,
            });
            valid = false;
        }

        if (beginDateState > new Date() || endDateState > new Date()) {
            sweetalert.fire({
                icon: "error",
                title: "",
                text: `Cannot search for ${label} Date in the future`,
            });
            valid = false;
        }

        if (beginDateState > new Date() || endDateState > new Date()) {
            sweetalert.fire({
                icon: "error",
                title: "",
                text: `Cannot search for ${label} Date in the future`,
            });
            valid = false;
        }
        return valid
    }

    const handleProviderChange = (e, stateToSet) => {
        setFilterObj((prevState) => ({
            ...prevState,
            [stateToSet]: e && e.label ? e.label : e
        }))
        handleFilteredTab()
    }

    const handleChange = (e, stateToSet, type = 'input', nullStateToSet = null) => {
        if (type === 'input') {
            setFilterObj((prevState) => ({
                ...prevState,
                [stateToSet]: e.target.value
            }))
        }
        else if (type === 'select') {
            setFilterObj((prevState) => ({
                ...prevState,
                [stateToSet]: e
            }))
        }
        else if (type === 'date' || type === 'phone') {
            setFilterObj((prevState) => ({
                ...prevState,
                [stateToSet]: null,
                [nullStateToSet]: e,
            }))
        }

        handleFilteredTab()
    }

    const handleDateOnChange = (value, nullState, state) => {
        if (value) {
            setFilterObj((prevState) => ({
                ...prevState,
                [nullState]: null,
                [state]: value
            }))
        } else {
            setFilterObj((prevState) => ({
                ...prevState,
                [nullState]: null,
                [state]: null
            }))
        }
    }

    //leaving here because this only occurs in the Sample Filter
    const getDateRange = (beginStateToSet, beginState, endStateToSet, endState, nullStateToSet, nullState, label, tooltip, options) => {
        return (
            <div className="form-group row">
                <div className={"col-10 col-md-8 pl-0"} data-toggle={"tooltip"} data-placement={"top"} title={tooltip} >
                    <label htmlFor={label} style={{ fontSize: "0.8em" }} className={"pt-1 font-weight-bold"} > {label} </label>
                </div>
                <div className="col-2">
                    {" "}
                    {beginState || endState || nullState ? (
                        <BsCheck className={"float-right"} color={"#141c54"} size={20} />
                    ) : null}
                </div>
                <div className={"col-12 col-md-10 pl-0 pr-1"}>
                    <div className="row">
                        <div className={"col-4"}>
                            <label id={`begin${label.replaceAll(' ', '')}Filter`} aria-label='' htmlFor='beginDate'>Begin: </label>
                        </div>
                        <div className={"col-8 text-lg-right"} id={label} >
                            <input
                                className={"form-control"}
                                autoComplete={"off"}
                                type={"date"}
                                name={"beginDate"}
                                aria-labelledby={`begin${label.replaceAll(' ', '')}Filter`}
                                onChange={(e) => handleDateOnChange(e.target.value, nullStateToSet, beginStateToSet)}
                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <label id={`end${label.replaceAll(' ', '')}Filter`} htmlFor='endDate'>End: </label>
                        </div>
                        <div className={"col-8 text-lg-right"} id={label}>
                            <input
                                className={"form-control"}
                                autoComplete={"off"}
                                type={"date"}
                                name={"endDate"}
                                aria-labelledby={`end${label.replaceAll(' ', '')}Filter`}
                                onChange={(e) => handleDateOnChange(e.target.value, nullStateToSet, endStateToSet)}
                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={label === 'Collection Date' ? "col-12" : "col-12 pl-md-1 pr-md-3 ml-md-2 pr-lg-4"}>
                            <div>
                                <Select styles={customStyles} isMulti={true} isSearchable={true} aria-label={label} placeholder={<div className="accessibilityText">Please Select...</div>} onChange={(e) => { setFilterObj((prevState) => ({ ...prevState, [beginStateToSet]: null, [endStateToSet]: null, [nullStateToSet]: e, })) }} className={"state_select"} options={options} value={nullState} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const handleActiveTab = (tab) => {
        switch (tab) {
            case 'appt':
                setIsApptTabActive(true)
                setIsSampleTabActive(false)
                setIsFacilityTabActive(false)
                setIsSubmitterTabActive(false)
                break;
            case 'sample':
                setIsApptTabActive(false)
                setIsSampleTabActive(true)
                setIsFacilityTabActive(false)
                setIsSubmitterTabActive(false)
                break;
            case 'facility':
                setIsApptTabActive(false)
                setIsSampleTabActive(false)
                setIsFacilityTabActive(true)
                setIsSubmitterTabActive(false)
                break;
            case 'submitter':
                setIsApptTabActive(false)
                setIsSampleTabActive(false)
                setIsFacilityTabActive(false)
                setIsSubmitterTabActive(true)
                break;
            default:
                break;
        }
    }

    const handleFilteredTab = () => {
        //Appointment tab
        if (!filterObj.ReqNum && !filterObj.LinkedApptsID && !filterObj.ServiceID && !filterObj.SubmittingProvider ) {
            setIsApptFilterActive(false)
        }
        else {
            setIsApptFilterActive(true)
        }

        //Sample tab
        if (!filterObj.SpecimenID && !filterObj.InternalSpecimenID && !filterObj.BatchNum && !filterObj.BinID && !filterObj.SpecimenSourceID && !filterObj.TestIDs && !filterObj.ResultIDs && !filterObj.Lot && !filterObj.BeginCollectionDate && !filterObj.EndCollectionDate && !filterObj.NullCollectionDate && !filterObj.BeginReceivedDate && !filterObj.EndReceivedDate && !filterObj.NullReceivedDate && !filterObj.BeginResultDate && !filterObj.EndResultDate && !filterObj.NullResultDate && !filterObj.BeginResultsApprovedDate && !filterObj.EndResultsApprovedDate && !filterObj.NullResultsApprovedDate && !filterObj.BeginResultsAccessedDate && !filterObj.EndResultsAccessedDate && !filterObj.NullResultsAccessedDate && !filterObj.BeginCreatedDate && !filterObj.EndCreatedDate && !filterObj.NullCreatedDate && !filterObj.BeginReportedDate && !filterObj.EndReportedDate && !filterObj.NullReportedDate && !filterObj.BeginTestOrderedDate && !filterObj.EndTestOrderedDate && !filterObj.NullTestOrderedDate && !filterObj.Status) {
            setIsSampleFilterActive(false)
        }
        else {
            setIsSampleFilterActive(true)
        }

        //Facility tab
        if (!filterObj.PodID && !filterObj.FacilityGroup && !filterObj.FacilityID) {
            setIsFacilityFilterActive(false)
        }
        else {
            setIsFacilityFilterActive(true)
        }

        //Submitter tab
        if (!filterObj.SubmitterFirstName && !filterObj.SubmitterLastName && !filterObj.SubmitterEmail && !filterObj.SubmitterPhone) {
            setIsSubmitterFilterActive(false)
        }
        else {
            setIsSubmitterFilterActive(true)
        }
    }

    React.useImperativeHandle(ref, () => ({
        preSubmitChecks() {
            let filteredObj = getFilterObj()
            let keys = Object.keys(filteredObj)
            let hasValue = keys.find((k) => filteredObj[k])
            let dateIsValid = true;

            if (!hasValue) {
                sweetalert.fire({
                    icon: "error",
                    title: "",
                    text: "Please choose a value to search",
                });
                return null
            }
            if (filterObj.BeginCreatedDate || filterObj.EndCreatedDate) {
                dateIsValid = dateCheck(filterObj.BeginCreatedDate, filterObj.EndCreatedDate, "Beginning Created", "Ending Created", "Created");
            }
            if (filterObj.BeginCollectionDate || filterObj.EndCollectionDate) {
                dateIsValid = dateCheck(filterObj.BeginCollectionDate, filterObj.EndCollectionDate, "Beginning Collection", "Ending Collection", "Collection");
            }
            if (filterObj.BeginReceivedDate || filterObj.EndReceivedDate) {
                dateIsValid = dateCheck(filterObj.BeginReceivedDate, filterObj.EndReceivedDate, "Beginning Received", "Ending Received", "Received");
            }
            if (filterObj.BeginResultDate || filterObj.EndResultDate) {
                dateIsValid = dateCheck(filterObj.BeginResultDate, filterObj.EndResultDate, "Beginning Result", "Ending Result", "Result");
            }
            if (filterObj.BeginResultsApprovedDate || filterObj.EndResultsApprovedDate) {
                dateIsValid = dateCheck(filterObj.BeginResultsApprovedDate, filterObj.EndResultsApprovedDate, "Beginning Results Approved", "Ending Results Approved", "Results Approved");
            }
            if (filterObj.BeginResultsAccessedDate || filterObj.EndResultsAccessedDate) {
                dateIsValid = dateCheck(filterObj.BeginResultsAccessedDate, filterObj.EndResultsAccessedDate, "Beginning Results Accessed", "Ending Results Accessed", "Results Accessed");
            }
            if (filterObj.BeginReportedDate || filterObj.EndReportedDate) {
                dateIsValid = dateCheck(filterObj.BeginReportedDate, filterObj.EndReportedDate, "Beginning Reported", "Ending Reported", "Reported");
            }
            if (filterObj.BeginTestOrderedDate || filterObj.EndTestOrderedDate) {
                dateIsValid = dateCheck(filterObj.BeginTestOrderedDate, filterObj.EndTestOrderedDate, "Beginning Test Ordered", "Ending Test Ordered", "Test Ordered");
            }

            if (dateIsValid) {
                return filteredObj
            }
            else {
                return null
            }
        },

        clear() {
            setFilterObj({
                AnimalType: null,
                PodID: null,
                FacilityID: null,
                FacilityGroup: null,
                SubmitterFirstName: "",
                SubmitterLastName: "",
                SubmitterEmail: "",
                SubmitterPhone: "",
                NullSubmitterPhone: null,
                Status: null,
                LinkedApptsID: "",
                ReqNum: "",
                BatchNum: "",
                SpecimenID: "",
                InternalSpecimenID: "",
                BinID: "",
                Lot: "",
                BeginCreatedDate: null,
                EndCreatedDate: null,
                NullCreatedDate: null,
                BeginCollectionDate: null,
                EndCollectionDate: null,
                NullCollectionDate: null,
                BeginReceivedDate: null,
                EndReceivedDate: null,
                NullReceivedDate: null,
                BeginResultDate: null,
                EndResultDate: null,
                NullResultDate: null,
                BeginResultsApprovedDate: null,
                EndResultsApprovedDate: null,
                NullResultsApprovedDate: null,
                BeginResultsAccessedDate: null,
                EndResultsAccessedDate: null,
                NullResultsAccessedDate: null,
                BeginReportedDate: null,
                EndReportedDate: null,
                NullReportedDate: null,
                ResultIDs: "",
                SpecimenSourceID: "",
                TestIDs: "",
                // ProviderFirstName: "",
                // ProviderLastName: "",
                ServiceID: null,
                BeginTestOrderedDate: null,
                EndTestOrderedDate: null,
                NullTestOrderedDate: null,
                SubmittingProvider: ""
            })
        }
    }))

    useEffect(() => {
        if (props.fromAdminHomeButtons && props.fromAdminHomeButtons.FacilityID) {

            // only facilityID is provided
            if (!props.fromAdminHomeButtons.processing && !props.fromAdminHomeButtons.completed) {
                setFilterObj({
                    AnimalType: null,
                    PodID: null,
                    FacilityID: [{ label: getNameFromID(props.fromAdminHomeButtons.FacilityID, props.facilities), value: props.fromAdminHomeButtons.FacilityID }],
                    FacilityGroup: null,
                    SubmitterFirstName: "",
                    SubmitterLastName: "",
                    SubmitterEmail: "",
                    SubmitterPhone: "",
                    NullSubmitterPhone: null,
                    Status: [{ label: "Processing", value: 1 }, { label: "Completed", value: 2 }],
                    LinkedApptsID: "",
                    ReqNum: "",
                    BatchNum: "",
                    SpecimenID: "",
                    InternalSpecimenID: "",
                    BinID: "",
                    Lot: "",
                    BeginCreatedDate: null,
                    EndCreatedDate: null,
                    NullCreatedDate: null,
                    BeginCollectionDate: null,
                    EndCollectionDate: null,
                    NullCollectionDate: null,
                    BeginReceivedDate: null,
                    EndReceivedDate: null,
                    NullReceivedDate: null,
                    BeginResultDate: null,
                    EndResultDate: null,
                    NullResultDate: null,
                    BeginResultsApprovedDate: null,
                    EndResultsApprovedDate: null,
                    NullResultsApprovedDate: null,
                    BeginResultsAccessedDate: null,
                    EndResultsAccessedDate: null,
                    NullResultsAccessedDate: null,
                    BeginReportedDate: null,
                    EndReportedDate: null,
                    NullReportedDate: null,
                    ResultIDs: "",
                    SpecimenSourceID: "",
                    TestIDs: "",
                    // ProviderFirstName: "",
                    // ProviderLastName: "",
                    ServiceID: null,
                    BeginTestOrderedDate: null,
                    EndTestOrderedDate: null,
                    NullTestOrderedDate: null,
                    SubmittingProvider: ""
                })
            }
            //if processing is true and completed is false
            else if (props.fromAdminHomeButtons.processing && !props.fromAdminHomeButtons.completed) {
                setFilterObj({
                    AnimalType: null,
                    PodID: null,
                    FacilityID: [{ label: getNameFromID(props.fromAdminHomeButtons.FacilityID, props.facilities), value: props.fromAdminHomeButtons.FacilityID }],
                    FacilityGroup: null,
                    SubmitterFirstName: "",
                    SubmitterLastName: "",
                    SubmitterEmail: "",
                    SubmitterPhone: "",
                    NullSubmitterPhone: null,
                    LinkedApptsID: "",
                    ReqNum: "",
                    BatchNum: "",
                    SpecimenID: "",
                    InternalSpecimenID: "",
                    BinID: "",
                    Lot: "",
                    BeginCreatedDate: null,
                    EndCreatedDate: null,
                    NullCreatedDate: null,
                    BeginCollectionDate: null,
                    EndCollectionDate: null,
                    NullCollectionDate: null,
                    BeginReceivedDate: null,
                    EndReceivedDate: null,
                    NullReceivedDate: null,
                    BeginResultDate: null,
                    EndResultDate: null,
                    NullResultDate: null,
                    BeginResultsApprovedDate: null,
                    EndResultsApprovedDate: null,
                    NullResultsApprovedDate: null,
                    BeginResultsAccessedDate: null,
                    EndResultsAccessedDate: null,
                    NullResultsAccessedDate: null,
                    BeginReportedDate: null,
                    EndReportedDate: null,
                    NullReportedDate: null,
                    ResultIDs: "",
                    SpecimenSourceID: "",
                    TestIDs: "",
                    // ProviderFirstName: "",
                    // ProviderLastName: "",
                    ServiceID: null,
                    //need to add this to backend
                    BeginTestOrderedDate: null,
                    EndTestOrderedDate: null,
                    NullTestOrderedDate: null,
                    Status: [{ label: "Processing", value: 1 }],
                    SubmittingProvider: ""
                })
            }
            //if completed is true
            else if (props.fromAdminHomeButtons.completed && !props.fromAdminHomeButtons.processing) {
                setFilterObj({
                    AnimalType: null,
                    PodID: null,
                    FacilityID: [{ label: getNameFromID(props.fromAdminHomeButtons.FacilityID, props.facilities), value: props.fromAdminHomeButtons.FacilityID }],
                    FacilityGroup: null,
                    SubmitterFirstName: "",
                    SubmitterLastName: "",
                    SubmitterEmail: "",
                    SubmitterPhone: "",
                    NullSubmitterPhone: null,
                    LinkedApptsID: "",
                    ReqNum: "",
                    BatchNum: "",
                    SpecimenID: "",
                    InternalSpecimenID: "",
                    BinID: "",
                    Lot: "",
                    BeginCreatedDate: null,
                    EndCreatedDate: null,
                    NullCreatedDate: null,
                    BeginCollectionDate: null,
                    EndCollectionDate: null,
                    NullCollectionDate: null,
                    BeginReceivedDate: null,
                    EndReceivedDate: null,
                    NullReceivedDate: null,
                    BeginResultDate: null,
                    EndResultDate: null,
                    NullResultDate: null,
                    BeginResultsApprovedDate: null,
                    EndResultsApprovedDate: null,
                    NullResultsApprovedDate: null,
                    BeginResultsAccessedDate: null,
                    EndResultsAccessedDate: null,
                    NullResultsAccessedDate: null,
                    BeginReportedDate: null,
                    EndReportedDate: null,
                    NullReportedDate: null,
                    ResultIDs: "",
                    SpecimenSourceID: "",
                    TestIDs: "",
                    // ProviderFirstName: "",
                    // ProviderLastName: "",
                    ServiceID: null,
                    BeginTestOrderedDate: null,
                    EndTestOrderedDate: null,
                    NullTestOrderedDate: null,
                    Status: [{ label: "Completed", value: 2 }]
                })
            }
        }
    }, [])



    useEffect(() => {
        handleFilteredTab()
    }, [filterObj])


    return (
        <div className="row">
            <div className="col-12">
                <nav className='d-md-none'>
                    <div className="nav nav-pills nav-fill mb-2" id="nav-tab" role="tablist" style={{ borderBottom: '0.1em solid lightgrey' }}>
                        <a className="nav-item nav-link active col-6 col-md-3" style={{ borderRight: '0.1em solid lightgrey', borderBottom: '0.1em solid lightgrey' }} id="nav-appointment-information-tab" data-toggle="tab" href="#nav-appointment-information" role="button" aria-controls="nav-appointment-information" aria-selected="true" onClick={() => handleActiveTab('appt')}>
                            Test Orders
                            <BsFilter className={isApptFilterActive ? "float-right" : "invisible"} color={isApptTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                        <a className="nav-item nav-link col-6 col-md-3" style={{ borderBottom: '0.1em solid lightgrey' }} id="nav-sample-information-tab" data-toggle="tab" href="#nav-sample-information" role="button" aria-controls="nav-sample-information" aria-selected="true" onClick={() => handleActiveTab('sample')}>
                            Sample
                            <BsFilter className={isSampleFilterActive ? "float-right" : "invisible"} color={isSampleTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                        <a className="nav-item nav-link col-6 col-md-3" style={{ borderRight: '0.1em solid lightgrey' }} id="nav-facility-information-tab" data-toggle="tab" href="#nav-facility-information" role="button" aria-controls="nav-facility-information" aria-selected="false" onClick={() => handleActiveTab('facility')}>
                            Facility
                            <BsFilter className={isFacilityFilterActive ? "float-right" : "invisible"} color={isFacilityTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                        <a className="nav-item nav-link col-6 col-md-3" id="nav-submitter-information-tab" data-toggle="tab" href="#nav-submitter-information" role="button" aria-controls="nav-submitter-information" aria-selected="false" onClick={() => handleActiveTab('submitter')}>
                            Submitter
                            <BsFilter className={isSubmitterFilterActive ? "float-right" : "invisible"} color={isSubmitterTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                    </div>
                </nav>
                <nav className='d-none d-md-block'>
                    <div className="nav nav-pills nav-fill mb-2" id="nav-tab" role="tablist" style={{ borderBottom: '0.1em solid lightgrey' }}>
                        <a className="nav-item nav-link active col-6 col-md-3" style={{ borderRight: '0.1em solid lightgrey' }} id="nav-appointment-information-tab" data-toggle="tab" href="#nav-appointment-information" role="button" aria-controls="nav-appointment-information" aria-selected="true" onClick={() => handleActiveTab('appt')}>
                            Test Orders
                            <BsFilter className={isApptFilterActive ? "float-right" : "invisible"} color={isApptTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                        <a className="nav-item nav-link col-6 col-md-3" style={{ borderRight: '0.1em solid lightgrey' }} id="nav-sample-information-tab" data-toggle="tab" href="#nav-sample-information" role="button" aria-controls="nav-sample-information" aria-selected="true" onClick={() => handleActiveTab('sample')}>
                            Sample
                            <BsFilter className={isSampleFilterActive ? "float-right" : "invisible"} color={isSampleTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                        <a className="nav-item nav-link col-6 col-md-3" style={{ borderRight: '0.1em solid lightgrey' }} id="nav-facility-information-tab" data-toggle="tab" href="#nav-facility-information" role="button" aria-controls="nav-facility-information" aria-selected="false" onClick={() => handleActiveTab('facility')}>
                            Facility
                            <BsFilter className={isFacilityFilterActive ? "float-right" : "invisible"} color={isFacilityTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                        <a className="nav-item nav-link col-6 col-md-3" id="nav-submitter-information-tab" data-toggle="tab" href="#nav-submitter-information" role="button" aria-controls="nav-submitter-information" aria-selected="false" onClick={() => handleActiveTab('submitter')}>
                            Submitter
                            <BsFilter className={isSubmitterFilterActive ? "float-right" : "invisible"} color={isSubmitterTabActive ? "aliceblue" : "#141c54"} size={20} />
                        </a>
                    </div>
                </nav>
                <div className="tab-content" id="nav-tabContent">
                    <div className="tab-pane fade show active" id="nav-appointment-information" role="tabpanel" aria-labelledby="nav-appointment-information-tab">
                        {/* appointment information card  */}
                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-4 px-5 pl-md-5 pr-md-0">
                                <CustomInput fromFilterPage={true} value={filterObj.ReqNum} label={"Confirmation Number"} aria-label={"Confirmation #"} tooltip={"A submitter's unique code tied to their sample"} handleChange={(e) => handleChange(e, "ReqNum")} />
                                <CustomInput fromFilterPage={true} value={filterObj.LinkedApptsID} label={"Appointment Number"} tooltip={"A submitter's unique code tied to their appointment"} handleChange={(e) => handleChange(e, "LinkedApptsID")} />
                                <span className='d-lg-none'>
                                    <CustomSelect fromFilterPage={true} value={filterObj.ServiceID} label={"Test Order"} tooltip={"Selected Test Order"} handleChange={(e) => handleChange(e, "ServiceID", 'select')} options={props.services} />
                                </span>
                            </div>
                            <div className='d-none d-md-block col-md-1 col-lg-4'>
                                <span className='d-md-none d-lg-block'>
                                    <CustomSelect fromFilterPage={true} value={filterObj.ServiceID} label={"Test Order"} tooltip={"Selected Test Order"} handleChange={(e) => handleChange(e, "ServiceID", 'select')} options={props.services} />
                                    {/* <CustomSelect fromFilterPage={true} value={filterObj.ApptCanceled} label={"Appointment Canceled"} tooltip={`Appointment status. "Yes" returns canceled appointments, "No" returns active appointments.`} handleChange={(e) => handleChange(e, "ApptCanceled", 'select')} options={getBoolOptionsWithNullString()} /> */}
                                </span>
                            </div>
                            <div className="col-12 col-md-5 col-lg-4 px-5 pl-md-0 pr-md-0">
                                {/* <span className='d-lg-none'>
                                    <CustomSelect fromFilterPage={true} value={filterObj.ApptCanceled} label={"Appointment Canceled"} tooltip={`Appointment status. "Yes" returns canceled appointments, "No" returns active appointments.`} handleChange={(e) => handleChange(e, "ApptCanceled", 'select')} options={getBoolOptionsWithNullString()} />
                                </span> */}
                                {/* <CustomInput fromFilterPage={true} value={filterObj.ProviderFirstName} label={"Provider First Name"} tooltip={"The first name of the Provider that is assigned to a sample"} handleChange={(e) => handleChange(e, "ProviderFirstName")} />
                                <CustomInput fromFilterPage={true} value={filterObj.ProviderLastName} label={"Provider Last Name"} tooltip={"The last name of the Provider that is assigned to a sample"} handleChange={(e) => handleChange(e, "ProviderLastName")} /> */}
                                {/* <CustomInput fromFilterPage={true} value={filterObj.SubmittingProvider} label={"Submitting Provider"} tooltip={"The full name of the Provider that is assigned to a sample"} handleChange={(e) => handleChange(e, "SubmittingProvider")} />  */}

                                <CustomSelect fromFilterPage={true} 
                                  value={filterObj?.SubmittingProvider} 
                                  label={"Submitting Provider"} 
                                  tooltip={`The full name of the Provider that is assigned to a sample`} 
                                  handleChange={(e) => handleProviderChange(e, "SubmittingProvider")} 
                                  options={props.submittingProviderList?.map(p => ({ label: p.FullName, value: p.ID }))} 
                                  // readOnly={this.disableCollectionRelevantFields("SubmittingProvider")} 
                                />
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="nav-sample-information" role="tabpanel" aria-labelledby="nav-sample-information-tab">
                        {/* sample information card  */}
                        <div className="row">
                            <div className="col-12 col-md-6 col-xxl-4 px-5 pl-md-5 pr-md-0">
                                <CustomInput fromFilterPage={true} value={filterObj.SpecimenID} label={"Specimen ID"} tooltip={"A unique identifier assigned to a sample"} handleChange={(e) => handleChange(e, "SpecimenID")} />
                                <CustomInput fromFilterPage={true} value={filterObj.InternalSpecimenID} label={"Internal Specimen ID"} tooltip={"A unique secondary identifier assigned to a sample"} handleChange={(e) => handleChange(e, "InternalSpecimenID")} />
                                {/* <CustomSelect fromFilterPage={true} value={filterObj.BatchNum} label={"Batch Number"} tooltip={`Assigned when processing a batch of test samples`} handleChange={(e) => handleChange(e, "BatchNum", 'select')} options={props.batchesForFilter} /> */}
                                {/* <CustomSelect fromFilterPage={true} value={filterObj.BinID} label={"Bin ID"} tooltip={`A unique identifier that ties a sample to receiving at the lab`} handleChange={(e) => handleChange(e, "BinID", 'select')} options={props.binIDsForFilter} /> */}
                                <CustomSelect fromFilterPage={true} value={filterObj.SpecimenSourceID} label={"Specimen Source"} tooltip={`The type of sample that was collected`} handleChange={(e) => handleChange(e, "SpecimenSourceID", 'select')} options={props.specimenSources} />
                                <CustomSelect fromFilterPage={true} value={filterObj.TestIDs} label={"Test Type"} tooltip={`The testing method`} handleChange={(e) => handleChange(e, "TestIDs", 'select')} options={props.tests} />
                                <CustomSelect fromFilterPage={true} value={filterObj.ResultIDs} label={"Result"} tooltip={`The result assigned to a sample`} handleChange={(e) => handleChange(e, "ResultIDs", 'select')} options={props.resultTypes} />
                                <span className='d-xxl-none'>
                                    {/* <CustomSelect fromFilterPage={true} value={filterObj.RerunFlag} label={"Rerun Flag"} tooltip={`Samples marked for rerun. "Yes" returns samples marked for rerun.`} handleChange={(e) => handleChange(e, "RerunFlag", 'select')} options={getBoolOptionsWithNullString()} /> */}
                                    {/* <CustomInput fromFilterPage={true} value={filterObj.Lot} label={"Lot"} tooltip={"Test lot number (e.g., rapid test lot number.)"} handleChange={(e) => handleChange(e, "Lot")} /> */}
                                    {getDateRange("BeginCollectionDate", filterObj.BeginCollectionDate, "EndCollectionDate", filterObj.EndCollectionDate, "NullCollectionDate", filterObj.NullCollectionDate, "Collection Date", "Date a test sample was collected.", getNullOptions())}
                                </span>
                                <CustomSelect fromFilterPage={true} value={filterObj.Status} label={"Status"} tooltip={`The status of the sample`} handleChange={(e) => handleChange(e, "Status", 'select')} options={props.statuses} />
                                <CustomSelect fromFilterPage={true} value={filterObj.AnimalType} label={"Animal Type"} tooltip={`The type of animal the sample came from.`} handleChange={(e) => handleChange(e, "AnimalType", 'select')} options={props.animalTypes} />
                            </div>
                            <div className='d-none d-md-block col-md-1 col-xxl-4'>
                                <span className='d-md-none d-xxl-block'>
                                    {/* <CustomSelect fromFilterPage={true} value={filterObj.RerunFlag} label={"Rerun Flag"} tooltip={`Samples marked for rerun. "Yes" returns samples marked for rerun.`} handleChange={(e) => handleChange(e, "RerunFlag", 'select')} options={getBoolOptionsWithNullString()} /> */}
                                    {/* <CustomInput fromFilterPage={true} value={filterObj.Lot} label={"Lot"} tooltip={"Test lot number (e.g., rapid test lot number.)"} handleChange={(e) => handleChange(e, "Lot")} /> */}
                                    {getDateRange("BeginCollectionDate", filterObj.BeginCollectionDate, "EndCollectionDate", filterObj.EndCollectionDate, "NullCollectionDate", filterObj.NullCollectionDate, "Collection Date", "Date a test sample was collected.", getNullOptions())}
                                    {getDateRange("BeginReceivedDate", filterObj.BeginReceivedDate, "EndReceivedDate", filterObj.EndReceivedDate, "NullReceivedDate", filterObj.NullReceivedDate, "Received Date", "The date a sample was received at the lab.", getNullOptions())}
                                    {getDateRange("BeginResultDate", filterObj.BeginResultDate, "EndResultDate", filterObj.EndResultDate, "NullResultDate", filterObj.NullResultDate, "Result Date", "Date a result was assigned to a test sample (note: results are not sent to the submitter until they're approved.", getNullOptions())}
                                    {getDateRange("BeginResultsApprovedDate", filterObj.BeginResultsApprovedDate, "EndResultsApprovedDate", filterObj.EndResultsApprovedDate, "NullResultsApprovedDate", filterObj.NullResultsApprovedDate, "Approved Date", "The date a result is approved and sent to the submitter.", getNullOptions())}
                                </span>
                            </div>
                            <div className="col-12 col-md-5 col-xxl-4 px-5 pl-md-0 pr-md-0">
                                <span className='d-xxl-none'>
                                    {getDateRange("BeginReceivedDate", filterObj.BeginReceivedDate, "EndReceivedDate", filterObj.EndReceivedDate, "NullReceivedDate", filterObj.NullReceivedDate, "Received Date", "The date a sample was received at the lab.", getNullOptions())}
                                    {getDateRange("BeginResultDate", filterObj.BeginResultDate, "EndResultDate", filterObj.EndResultDate, "NullResultDate", filterObj.NullResultDate, "Result Date", "Date a result was assigned to a test sample (note: results are not sent to the submitter until they're approved.", getNullOptions())}
                                </span>
                                {/* {getDateRange("BeginResultsAccessedDate", filterObj.BeginResultsAccessedDate, "EndResultsAccessedDate", filterObj.EndResultsAccessedDate, "NullResultsAccessedDate", filterObj.NullResultsAccessedDate, "Accessed Date", "The date a submitter first accessed their test results.", getNullOptions())} */}
                                {getDateRange("BeginCreatedDate", filterObj.BeginCreatedDate, "EndCreatedDate", filterObj.EndCreatedDate, "NullCreatedDate", filterObj.NullCreatedDate, "Created Date", "The date that a submitter record was created using the Appointment or Submission form.", getNullOptions())}
                                {getDateRange("BeginReportedDate", filterObj.BeginReportedDate, "EndReportedDate", filterObj.EndReportedDate, "NullReportedDate", filterObj.NullReportedDate, "Reported Date", "The date that the sample has been reported to SpringML.", getNullOptions())}
                                {getDateRange("BeginTestOrderedDate", filterObj.BeginTestOrderedDate, "EndTestOrderedDate", filterObj.EndTestOrderedDate, "NullTestOrderedDate", filterObj.NullTestOrderedDate, "Test Ordered Date", "The date that the test was ordered.", getNullOptions())}
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="nav-facility-information" role="tabpanel" aria-labelledby="nav-facility-information-tab">
                        {/* facility information card  */}
                        <div className="row">
                            <div className="col-12 col-md-6 col-lg-4 px-5 pl-md-5 pr-md-0">
                                {/* <CustomSelect fromFilterPage={true} value={filterObj.PodID} label={"Schedule"} tooltip={`Lists the Schedule ID, Facility Name, and Schedule Date`} handleChange={(e) => handleChange(e, "PodID", 'select')} options={props.pods} disabled={filterObj.FacilityGroup || filterObj.FacilityID} /> */}
                                <CustomSelect fromFilterPage={true} value={filterObj.FacilityID} label={"Facility"} tooltip={`Testing locations by name`} handleChange={(e) => handleChange(e, "FacilityID", 'select')} options={props.facilities} disabled={filterObj.FacilityGroup || filterObj.PodID} />
                                <span className='d-lg-none'>
                                    <CustomSelect fromFilterPage={true} value={filterObj.FacilityGroup} label={"Facility Group"} tooltip={`Facility Group", "Group facility is assigned to`} handleChange={(e) => handleChange(e, "FacilityGroup", 'select')} options={props.facilityGroups} disabled={filterObj.FacilityID || filterObj.PodID} />
                                </span>
                            </div>
                            <div className='d-none d-md-block col-md-1 col-lg-4'>
                                <span className='d-md-none d-lg-block'>
                                    <CustomSelect fromFilterPage={true} value={filterObj.FacilityGroup} label={"Facility Group"} tooltip={`Facility Group", "Group facility is assigned to`} handleChange={(e) => handleChange(e, "FacilityGroup", 'select')} options={props.facilityGroups} disabled={filterObj.FacilityID || filterObj.PodID} />
                                </span>
                            </div>
                            {/* <div className="col-12 col-md-5 col-lg-4 px-5 pl-md-0 pr-md-0">
                                <CustomSelect fromFilterPage={true} value={filterObj.FacilityID} label={"Facility"} tooltip={`Testing locations by name`} handleChange={(e) => handleChange(e, "FacilityID", 'select')} options={props.facilities} disabled={filterObj.FacilityGroup || filterObj.PodID} />
                            </div> */}
                        </div>
                    </div>
                    <div className="tab-pane fade" id="nav-submitter-information" role="tabpanel" aria-labelledby="nav-submitter-information-tab">
                        {/* submitter information card  */}
                        <div className="row">
                            <div className="col-12 col-md-6 col-xxl-4 px-5 pl-md-5 pr-md-0">
                                <CustomInput fromFilterPage={true} value={filterObj.SubmitterFirstName} label={"First Name"} tooltip={"The first name of the Submitter"} handleChange={(e) => handleChange(e, "SubmitterFirstName")} />
                                <CustomInput fromFilterPage={true} value={filterObj.SubmitterLastName} label={"Last Name"} tooltip={"The last name of the Submitter"} handleChange={(e) => handleChange(e, "SubmitterLastName")} />
                                <CustomInput fromFilterPage={true} value={filterObj.SubmitterEmail} label={"Email"} tooltip={"The email of the Submitter"} handleChange={(e) => handleChange(e, "SubmitterEmail")} />
                                <CustomPhone fromFilterPage={true} value={filterObj.SubmitterPhone} nullValue={filterObj.NullSubmitterPhone} label={"Phone"} tooltip={`The phone number of the Submitter`} handleDateOnChange={(e) => handleDateOnChange(e, "NullSubmitterPhone", "SubmitterPhone")} handleChange={(e) => handleChange(e, "SubmitterPhone", "phone", "NullSubmitterPhone")} options={getNullOptions()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default React.forwardRef(AnimalSampleFilterTabs)